/* eslint-disable jsx-a11y/anchor-has-content */
import "./App.css";
import About from "./components/About";
import Contact from "./components/Contact";
import Experience from "./components/Experience";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navigation from "./components/Navigation";
import { useInitialHashScroll } from "./hooks/useInitialHashScroll";
import { useSectionReveal } from "./hooks/useSectionReveal";

function App() {
  useSectionReveal();
  useInitialHashScroll();

  return (
    <div className="site-shell">
      <a alt="Skip to content" className="skip-link" href="#main-content"/>
      
      <Navigation />
      <main id="main-content">
        <Hero />
        <About />
        <Experience />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
